/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const SHORT_DESC_ERR = 'Short Description is Required.';
export const LONG_DESC_ERR = 'Long Description is Required.';
export const REBETE_PGM_ERR = 'Rebate Program Code is Required.';
export const REBETE_PGM_INVALID_ERR = 'Rebate Program Code already exist.';
export const CHECK_PAY_ERR = 'Check Payee is Required.';
export const CMS64_ERR = 'CMS 64 agency for Federal Programs is Required.';
export const STATE_ERR = 'State is Required.';
export const EARLIER_QTR_ERR = 'Earliest Quarter for Drug Details is Required.';
export const DEBIT_MANUFACTURERS_ERR =
  'Number of Debit Manufacturers should be numeric.';
export const CREDIT_MANUFACTURERS_ERR =
  'Number of Credit Manufacturers should be numeric.';
export const REPORT_BALANCE_DUE_REQ_ERR =
  'Report balance due threshold is Required.';
export const REPORT_BALANCE_DUE_ERR =
  'Report balance due threshold should be numeric.';
export const SEND_ALL_RETAINED_QTR =
  'Send all Retained Quarter value should be from 0-4.';
export const INVOICE_MAIL_ERR =
  'Invoice Mail Threshold value should be less than $50.';
export const ADD_URA_SRC_DATA = {
  startQtr: '',
  rpcParamTypeCd: 'URA_SOURCE_CD',
  endQtr: null,
  rpcParamValue: '',
  newFlag: true,
};
export const ADD_URA_CALC_DATA = {
  effectiveQtr: '',
  calcTypeCd: 'URA',
  calcMethodCd: '-1',
  calcFixedPct: null,
  calcGenericPct: null,
  newFlag: true,
};
export const ADD_URA_PAY_DATA = {
  startQtr: '',
  rpcParamTypeCd: 'CHG_URA_FROM_PMT_IND',
  endQtr: null,
  rpcParamValue: '0',
  newFlag: true,
};
export const ADD_INT_CALC_DATA = {
  effectiveQtr: '',
  calcTypeCd: 'INT',
  calcMethodCd: '-1',
  calcFixedPct: null,
  calcGenericPct: null,
  newFlag: true,
};
export const ADD_FED_DATA = {
  startQtr: '',
  rpcParamTypeCd: 'FED_REG_PCT',
  endQtr: null,
  rpcParamValue: '',
  newFlag: true,
};
export const ADD_FED_FMLY_DATA = {
  startQtr: '',
  rpcParamValue: '',
  newFlag: true,
  rpcParamTypeCd: 'FED_FP_PCT',
};
export const ADD_CMS_RPT_DATA = {
  cmsRptGroupName: '',
  cmsRptGroupNum: '',
  cmsRptTitle: '',
  endQtr: '',
  startQtr: '',
  newFlag: true,
};
export const ADD_CMS_UTIL_DATA = {
  cmsUtilGroupName: '',
  cmsUtilGroupNum: '',
  endQtr: '',
  startQtr: '',
  newFlag: true,
};
export const ADD_ENROLL_DATA = {
  enrollmentTimingCd: '-1',
  numOfLives: '',
  qtr: '',
  newFlag: true,
};
export const DTLS_ERR = [
  'shtDescErr',
  'longDescErr',
  'checkPayErr',
  'cms64Err',
  'stateErr',
  'dbalModThresholdErr',
  'rptBalanceDueThresholdErr',
  'numOfDebitMfgErr',
  'numOfCreditMfgErr',
  'fiscalYrErr',
  'lastQtrWithoutClaimsErr',
  'firstSummaryRptQtrErr',
  'dramsInvoiceStartQtrErr',
  'frgvWoffThresholdErr',
  'fiscalYrReqErr',
  'lastQtrWithoutClaimsReqErr',
  // 'dramsInvoiceStartQtrReqErr',
  // 'firstSummaryRptQtrReqErr',
  'rptBalanceDueThresholdReqErr',
  'dbalModThresholdReqErr',
  'dayCountReqErr',
  'drugTypeSourceCdReqErr',
  'claimRebateProgramCdReqErr',
];
export const INVOICE_ERR = [
  'invoiceHdrLineErr',
  'nonCmsDrugInclQtrsReqErr',
  'nonCmsDrugInclQtrsVldErr',
  'nonCmsDrugInclCdErr',
  'oldInvoicePrefixErr',
];
export const OVRD_ERR = [
  'earlierQtrReqErr',
  'earlierQtrQtrErr',
  'sendAllRetainedQtrErr',
  'invoiceMailThresholdErr',
];
export const AUDIT_ERR = [
  'IRGLtestPctErr',
  'IRGRtestPctErr',
  'IRGPtestPctErr',
  'IUNPtestPctErr',
  'CSTRtestAmtErr',
  'CRLAtestAmtErr',
  'CSRAtestAmtErr',
  'CAEStestAmtErr',
  'CUNAtestAmtErr',
];
export const URA_SRC_QTR_ERR =
  'Start Quarter is required for URA Source in Row';
export const URA_CALC_QTR_ERR =
  'Effective Quarter is required for URA Calculation in Row';
export const URA_PAY_QTR_ERR =
  'Start Quarter is required for Update URA from Payments in Row';
export const INT_CALC_QTR_ERR =
  'Start Quarter is required for Interest Calculation in Row';
export const INT_FED_QTR_ERR = 'Start Quarter is required for Federal % in Row';
export const INT_FED_FMLY_QTR_ERR =
  'Start Quarter is required for Federal Family Planning % in Row';
export const CMS_UTIL_SRT_QTR_ERR =
  'Start Quarter is required for CMS Utilization in Row';
export const CMS_RPT_SRT_QTR_ERR =
  'Start Quarter is required for CMS Report in Row';
export const CMS_UTIL_END_QTR_ERR =
  'End Quarter is required for CMS Utilization in Row';
export const CMS_RPT_END_QTR_ERR =
  'End Quarter is required for CMS Report in Row';
export const QTR_ENROLL_ERR = 'Quarter is required for Enrollment in Row';
export const ENROLL_TIMING_ERR = 'Enrollment Timing Code is required in Row';
export const GROUP_NAME_ERR = 'Group Name is required';
export const GRP_NUM_ERR = 'Group Number is required';
export const REPORT_TTL_ERR = 'Report Title is required';
export const GRP_NUM_NUMERIC_ERR = 'Group Number should be numeric';
export const INT_FED_PAST_ERR = 'Cannot Add/Edit percentage for a past quarter';
export const PERCENT_REQ_ERR = 'Percent is required';
export const PERCENT_NUM_ERR = 'Percent should be numeric';
export const CALC_MTHD_ERR = 'Calc Method is required';
export const LAST_QTR_REQ_ERR = 'Last Quarter Without Claims is Required.';
// export const DRAMS_QTR_REQ_ERR = 'Drams Invoice Start Quarter is Required.';
// export const FIRST_SUMMARY_QTR_REQ_ERR =
//   'First Summary Report Quarter is Required.';
export const ENROLL_LESS_QTR_ERR =
  'Enrollment Quarter cannot be less than the last frozen quarter';
export const FISCAL_YR_REQ_ERR = 'Fiscal year begin month/day is Required.';
export const FISCAL_YR_ERR =
  'Fiscal year begin month/day must be in the format MM/DD or MMDD.';
export const END_QTR_ERR = 'End Quarter should be greater than Start Quarter';

export const START_QTR_OVERLAP_ERR = 'Start Quarter should not overlap';
export const END_QTR_OVERLAP_ERR = 'End Quarter should not overlap';

export const MAINTAIN_ROUTE = '/maintainRebate';
export const CREATE_NEW = '/createRebate';
export const SEARCH_ROUTE = '/SearchRebate';
export const INVOICE_HEADER_ERR = 'Invoice Header is Required.';
export const INCLUSION_CODE_ERR =
  'Inclusion code for drugs Not on CMS is Required.';
export const INCLUSION_QTR_ER =
  'Select Inclusion code for Drugs not on CMS requires a quarter value.';
export const URA_ERR = 'A URA Source is Required.';
export const CMS_REPORTING_ERR =
  'Start Quarter is required for CMS Reporting in Row';
export const CMS_UTILIZATION_ERR =
  'Start Quarter is required for CMS Utilization in Row';
export const ENTROLL_TIME_ERR =
  'Enrollment Timing Code is required for CMS Utilization in Row';
export const INVALID_QTR_ERR =
  'Please enter a valid quarter and year in the form #Q## or #Q#### such as 1Q98 OR 1Q1998';
export const UNIQ_CMS_UTIL = 'Please input unique quarter for CMS Utilization';
export const UNIQ_CMS_RPT = 'Please input unique quarter for CMS Report';
export const UNIQ_URA_SRC = 'Please input unique quarter for URA Source';
export const UNIQ_URA_CALC = 'Please input unique quarter for URA Calculation';
export const UNIQ_URA_PAY =
  'Please input unique quarter for Update URA from Payment';
export const UNIQ_INT_CALC =
  'Please input unique quarter for Interest Calculation';
export const UNIQ_INT_FED = 'Please input unique quarter for Federal %';
export const UNIQ_INT_FED_FAM =
  'Please input unique quarter for Federal Family Planning %';
export const UNIQ_ENROLL = 'Please input unique quarter for Enrollment Quarter';
export const PRECENT_QTR_ERR = 'Cannot Add/Edit percentage for a past quarter';
export const URA_CALC_EFFECTIVE_QTR =
  'Effective Quarter must be after the URA Source Start Quarter';
export const FROZEN_QTR_ERR =
  'The Effective Quarter must be after the last frozen qtr ';
export const THRESHOLD_UNIT_ERR =
  'Threshold number of units is required for Row';
export const MAIL_ORDER_ERR = 'Mail Order Multiplier is required for Row';
export const THRESHOLD_UNIT_NUM_ERR =
  'Threshold number of units should be numeric';
export const MAIL_ORDER_NUM_ERR = 'Mail Order Multiplier should be numeric';
export const MAINTAIN_REBATE_TITLE = 'Maintain Rebate Program';
export const USE_DEFAULT_CONFIRM_MSG =
  'If you choose this, all Audit AND Unit Type Audit information that you have entered will be erased!. Is this what you want?';
export const FORGIVE_THRESHOLD_NUM_ERR =
  'Forgive/Write-Off Threshold should be numeric.';
export const OLD_INVOICE_PREFIX_NUM_ERR =
  'Old Invoice Prefix should be numeric.';
export const INCLUSION_QTR_VLD_ER = '# of Quarters should be numeric.';
export const CMS_FREEZE_RPT_ERR =
  'End quarter in CMS Reporting Group cannot be less than last CMS frozen quarter ';
export const CMS_FREEZE_UTIL_ERR =
  'End quarter in CMS Utilization Group cannot be less than last CMS frozen quarter ';
export const AVG_PER_REQ_ERR =
  'Percent average units is required and should be numeric.';
export const PER_SUB_ERR =
  'Percent submitted amount is required and should be numeric.';
export const PER_ALLOW_ERR =
  'Percent allowed amount is required and should be numeric.';
export const THRES_AMT_ERR =
  'Threshold amount is required and should be numeric.';
export const PER_PRIOR_ERR =
  'Percent prior quarter is required and should be numeric.';
export const PER_REB_AMT_ERR =
  'Percent reimbursed amount is required and should be numeric.';
export const DEC_THRES_ERR =
  'Declare Balanced/Modified Units Threshold shuold be numeric.';
export const DEC_THRES_REQ_ERR =
  'Declare Balanced/Modified Units Threshold is Required.';
export const URA_CALC_REQ =
  'The Current URA source has been set to CALC, therefore a URA Calculation method is Required.';
export const DAY_COUNT_REQ_ERR = 'Day Counting Method For Letters is Required.';
export const DRUG_TYPE_REQ_ERR = 'Drug Type Source is Required.';
export const CLAIM_REBATE_PGM_REQ_ERR =
  'Claim Rebate Program Code is Required.';
